export default "__VITE_ASSET__B4u$BQyt__"